module.exports = __webpack_public_path__ + "static/media/statement_homepage.da629343.avif";